module.exports = __webpack_public_path__ + "img/slide7.05c24a0a.png";